import React, { useEffect, useState } from 'react';
import './index.css';
import { useParams } from 'react-router-dom';

const AdmissionTable = () => {
    const { id } = useParams();
    const [enquiries, setEnquiries] = useState([]);
    const [filteredEnquiries, setFilteredEnquiries] = useState([]);
    const [filter, setFilter] = useState('today');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const api = process.env.REACT_APP_API;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('jwt_token');
                const response = await fetch(`${api}/admissions`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }

                const result = await response.json();
                console.log("API Response:", result);

                const data = Array.isArray(result) ? result : result.data;

                if (!Array.isArray(data)) {
                    throw new Error('Invalid data format received from API');
                }

                const filteredData = data.filter(item => item.centerName === id);
                const sortedData = filteredData.sort((a, b) => new Date(b.dateOfJoining) - new Date(a.dateOfJoining));
                setEnquiries(sortedData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [id, api]);

    useEffect(() => {
        const filterData = () => {
            const now = new Date();
            let filteredData;

            if (filter === 'today') {
                filteredData = enquiries.filter(enquiry => {
                    const enquiryDate = new Date(enquiry.dateOfJoining);
                    return (
                        enquiryDate.getDate() === now.getDate() &&
                        enquiryDate.getMonth() === now.getMonth() &&
                        enquiryDate.getFullYear() === now.getFullYear()
                    );
                });
            } else if (filter === 'yesterday') {
                const yesterday = new Date(now);
                yesterday.setDate(now.getDate() - 1);
                filteredData = enquiries.filter(enquiry => {
                    const enquiryDate = new Date(enquiry.dateOfJoining);
                    return (
                        enquiryDate.getDate() === yesterday.getDate() &&
                        enquiryDate.getMonth() === yesterday.getMonth() &&
                        enquiryDate.getFullYear() === yesterday.getFullYear()
                    );
                });
            } else if (filter === 'lastMonth') {
                const lastMonth = new Date(now);
                lastMonth.setMonth(now.getMonth() - 1);
                filteredData = enquiries.filter(enquiry => {
                    const enquiryDate = new Date(enquiry.dateOfJoining);
                    return (
                        enquiryDate.getMonth() === lastMonth.getMonth() &&
                        enquiryDate.getFullYear() === lastMonth.getFullYear()
                    );
                });
            } else {
                filteredData = enquiries;
            }

            setFilteredEnquiries(filteredData);
        };

        filterData();
    }, [filter, enquiries]);

    const handleDateRangeFilter = () => {
        if (!fromDate || !toDate) {
            alert('Please select both From and To dates');
            return;
        }

        const from = new Date(fromDate);
        const to = new Date(toDate);
        const filteredData = enquiries.filter(enquiry => {
            const enquiryDate = new Date(enquiry.dateOfJoining);
            return enquiryDate >= from && enquiryDate <= to;
        });

        setFilteredEnquiries(filteredData);
        setFilter('');
    };

    return (
        <div className="table-container">
            <div className='head-container'>
                <h1 className='center-name' style={{ fontSize: "36px" }}>{id} Admissions</h1>
                <h2 className="total-count">Total: {filteredEnquiries.length}</h2>
            </div>

            <div className="filters">
                <select value={filter} onChange={(e) => setFilter(e.target.value)}>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="lastMonth">Last Month</option>
                    <option value="">Custom Range</option>
                </select>

                {filter === '' && (
                    <div className="custom-date-range">
                        <label>
                            From: <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                        </label>
                        <label>
                            To: <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                        </label>
                        <button onClick={handleDateRangeFilter}>Apply</button>
                    </div>
                )}
            </div>

            <table className="enquiry-table">
                <thead>
                    <tr>
                        <th>Student Name</th>
                        <th>Course</th>
                        <th>Total Fees</th>
                        <th>Paid Fees</th>
                        <th>Joining Date</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredEnquiries.length > 0 ? (
                        filteredEnquiries.map((entry) => (
                            <tr key={entry._id}>
                                <td>{entry.name}</td>
                                <td>{entry.course}</td>
                                <td>{entry.totalFees}</td>
                                <td>{entry.paidFees}</td>
                                <td>{new Date(entry.dateOfJoining).toLocaleDateString()}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center' }}>No records found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default AdmissionTable;
